const updates = [
  { time: '10分钟前', tag: '最新', content: '千万粉带货主播"XX"直播翻车，假货鉴定报告流出，品牌方紧急解约', tagColor: 'primary' },
  { time: '28分钟前', tag: '实锤', content: '某抖音头部网红税务问题被立案，涉案金额或超3000万', tagColor: 'primary' },
  { time: '1小时前', tag: '扒皮', content: '快手情感博主"XX"被前助理实名爆料，私下人设与镜头前截然相反', tagColor: 'accent' },
  { time: '2小时前', tag: '热议', content: '网红"XX"与经纪公司对簿公堂，千万违约金合同细节曝光', tagColor: 'secondary' },
  { time: '3小时前', tag: '跟进', content: '此前被曝私生活混乱的舞蹈网红再添新锤，多名当事人发声', tagColor: 'secondary' },
  { time: '5小时前', tag: '独家', content: '知名美妆博主"XX"代工厂实拍流出，所谓"自主研发"实为贴牌', tagColor: 'accent' },
  { time: '7小时前', tag: '爆料', content: '某搞笑类大号运营团队内讧，核心编导出走内幕深度解析', tagColor: 'secondary' },
  { time: '9小时前', tag: '吃瓜', content: '两大百万粉网红朋友圈互撕升级，背后牵出行业潜规则利益链', tagColor: 'secondary' },
  { time: '12小时前', tag: '回顾', content: '2026上半年网红塌房事件大盘点：从人设崩塌到法律追责全记录', tagColor: 'secondary' },
];

const tagBgMap: Record<string, string> = {
  primary: 'bg-primary-500/15 text-primary-400 border-primary-500/25',
  accent: 'bg-accent-500/15 text-accent-400 border-accent-500/25',
  secondary: 'bg-secondary-500/15 text-secondary-400 border-secondary-500/25',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">最新动态</h2>
            <p className="mt-2 text-sm text-foreground-500">全天候追踪网红圈最新黑料，不错过每一个翻车现场</p>
          </div>

          <div className="max-w-3xl mx-auto space-y-0">
            {updates.map((item, idx) => (
              <div
                key={idx}
                className="relative flex items-start gap-4 py-4 border-b border-background-200/60 last:border-b-0 group cursor-pointer hover:bg-background-100/50 px-3 -mx-3 rounded-lg transition-colors duration-200"
              >
                <div className="flex-shrink-0 mt-1">
                  <span className={`inline-block text-xs font-medium px-2 py-0.5 rounded border whitespace-nowrap ${tagBgMap[item.tagColor]}`}>
                    {item.tag}
                  </span>
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm text-foreground-700 leading-relaxed group-hover:text-foreground-900 transition-colors duration-200">
                    {item.content}
                  </p>
                </div>
                <div className="flex-shrink-0 mt-0.5">
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}